module.exports = __webpack_public_path__ + "static/media/exp.d1efdad9.png";